import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { AccountingRepository } from '@core/repositories/accounting.repository';
import * as moment from 'moment';
import { Observable, of } from 'rxjs';
import { TypeEvent } from '@app/shared/interfaces/accounting';

export class FakeAccountingRepository implements AccountingRepository {
  public date = moment().format('YYYYMMDD');
  public montAndYear = moment().format('MMYYYY');
  public filename = {
    downloadBalanceInterface: 'Reporte_Interfaz_Saldos_GNM_' + this.date + '.txt',
    downloadMovementInterface: 'Reporte_Interfaz_Movimientos_GNM_' + this.date + '.txt',
    downloadTransactionsEvents: 'Reporte_Transacciones_Eventos_GNM_' + this.date + '.csv',
    downloadMasterTransfers: 'Reporte_Maestro_GNM_' + this.date + '.csv',
    downloadTransactionsLogEvents: 'Reporte_Log_modificaciones_'+ this.date + '.csv',
    downloadTotalsCosts: '1GIR'+ this.montAndYear + '.txt',
    downloadTotalsCostsSentinel: 'NGIR'+ this.montAndYear + '.txt'
  };

  private download(name: string) {
    return of(
      new HttpResponse<any>({
        body: 'local',
        headers: this.setHeader(name, 'text/x-csv'),
        status: 200,
        statusText: 'OK',
        url: 'localhost'
      })
    );
  }

  dataTypeEvent = {
    data: [
      {
        name: 'celular',
        label: 'Celular'
      },
      {
        name: 'documentoIdentidad',
        label: 'Documento de identidad'
      },
      {
        name: 'reverso',
        label: 'Reverso'
      },
      {
        name: 'anulaciones',
        label: 'Anulaciones'
      }
    ]
  };

  downloadBalanceInterface(data: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return this.download(this.filename.downloadBalanceInterface);
  }

  downloadMasterTransfers(data: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return this.download(this.filename.downloadMasterTransfers);
  }

  downloadMovementInterface(data: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return this.download(this.filename.downloadMovementInterface);
  }

  downloadTransactionsEvents(data: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return this.download(this.filename.downloadTransactionsEvents);
  }

  downloadTransactionsLogEvents(data: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });
    
    return this.download(this.filename.downloadTransactionsLogEvents);
  }

  downloadTotalsCosts(data: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return this.download(this.filename.downloadTotalsCosts);
  }

  downloadTotalsCostsSentinel(data: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return this.download(this.filename.downloadTotalsCostsSentinel);
  }

  private setHeader(fileName: string, type: string) {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set(
      'Content-Disposition',
      'attachment;filename=' + fileName
    );
    header = header.set('Content-Type', type);
    header = header.set('Content-Length', '3');
    return header;
  }

  getTypeEvent(): Observable<any> {
    return of(this.dataTypeEvent);
  }
}
